import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    column: {
        width: "20%"
    },
    expiredNote: {
        fontSize: theme.typography.pxToRem(11),
        marginTop: theme.spacing(0.5)
    }
}))